import { useMemo } from 'react';
import { useTheme } from './ThemeProvider';
import { createCommonStyles } from './common';

/**
 * Returns the design-system primitives (`screenContainer`, `primaryButton`,
 * `formInput`, etc.) for the active theme. Memoized — only re-computes when
 * the active theme changes (which happens when the user toggles the
 * preference in Profile → Appearance, or when the OS dark/light setting
 * changes if their preference is `'system'`).
 *
 * Replaces the static `commonStyles` import. Existing pattern:
 *
 *     import { commonStyles } from '../styles/common';
 *     // ... commonStyles.primaryButton ...
 *
 * Becomes:
 *
 *     import { useCommonStyles } from '../styles/useCommonStyles';
 *     function Component() {
 *       const commonStyles = useCommonStyles();
 *       // ... commonStyles.primaryButton ...
 *     }
 */
export function useCommonStyles() {
  const theme = useTheme();
  return useMemo(() => createCommonStyles(theme), [theme]);
}
